module.exports = __webpack_public_path__ + "media/military/military_gi_btn-f3298386.png";